import React from 'react';
import styled from 'styled-components';
import { ntvImages } from '../../Theming/images';
import { themeColor, mobileMediaQuery } from '../../Theming';
import { useIsIPad } from '../../Common/Analytics/utils';

const Container = styled.div<{ height?: number; isIPad?: boolean }>`
  height: ${({ height, isIPad }) => {
    if (height) {
      return isIPad ? `${height + 40}px` : `${height}px`;
    }
    return isIPad ? '330px' : '190px';
  }};
  background-color: #2d3c46;
  position: relative;

  & > img {
    width: ${({ isIPad }) => (isIPad ? '85%' : '100%')};
    height: auto;
    position: absolute;
    top: ${({ isIPad }) => (isIPad ? '50%' : '0')};
    left: ${({ isIPad }) => (isIPad ? '50%' : '0')};
    transform: ${({ isIPad }) => (isIPad ? 'translate(-50%, -50%)' : 'none')};
  }
`;

const MainContent = styled.div<{
  logoWidth?: number;
  androidAccessibility?: boolean;
  isIPad?: boolean;
}>`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: ${({ androidAccessibility }) =>
    androidAccessibility ? 'center' : 'flex-end'};
  align-items: center;
  height: 100%;
  margin-top: ${({ androidAccessibility }) =>
    androidAccessibility ? '-30px' : '15px'};
  width: ${({ isIPad }) => (isIPad ? '100vw' : '100%')};

  & > img {
    position: relative;
    width: ${({ logoWidth, isIPad }) => {
      if (logoWidth) {
        return isIPad ? `${logoWidth + 30}px` : `${logoWidth}px`;
      }
      return isIPad ? '107px' : '77px';
    }};
  }

  & > a {
    color: #e1e6eb;
    font-size: ${({ isIPad }) => (isIPad ? '20px' : '16px')};
    margin-bottom: ${({ isIPad }) => (isIPad ? '48px' : '32px')};
  }

  & > p {
    margin: ${({ isIPad }) => (isIPad ? '16px 0 45px 0' : '12px 0 30px 0')};
    padding: 0;
    color: ${themeColor('white')};
    font-size: ${({ isIPad }) => (isIPad ? '32px' : '26px')};
    font-weight: 600;
    text-align: center;

    & > span {
      display: block;
    }

    ${mobileMediaQuery} {
      font-size: 26px;
      margin: 12px 16px 30px 16px;
      line-height: 1.3;
    }
  }
`;

const SafeArea = styled.div`
  background-color: #2d3c46;
  height: 50px;
`;

interface Props {
  showBrands?: boolean;
  logoWidth?: number;
  showFAQ?: boolean;
  text?: React.ReactNode;
  height?: number;
  androidAccessibility?: boolean;
}

const Header = ({
  showBrands,
  logoWidth,
  showFAQ,
  text,
  height,
  androidAccessibility,
}: Props) => {
  const isIPad = useIsIPad();
  return (
    <>
      {androidAccessibility && <SafeArea aria-hidden="true" />}
      <Container height={height} isIPad={isIPad}>
        {showBrands && (
          <img src={ntvImages.ntv_brands.default} alt="Popular Brands" />
        )}
        <MainContent
          logoWidth={logoWidth}
          androidAccessibility={androidAccessibility}
          isIPad={isIPad}
        >
          <img src={ntvImages.ntv_logo.default} alt="NTV Logo" />
          {text && <p className="text">{text}</p>}
          {showFAQ && (
            <a
              target="_blank"
              href="https://event.kindred.co/ntv-faqs"
              rel="noreferrer"
              className="faq"
            >
              Häufig gestellte Fragen
            </a>
          )}
        </MainContent>
      </Container>
    </>
  );
};

export default Header;
